import React, { useState, useEffect } from "react";
import { getDefects, deleteDefect } from "../../services/api";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/BreadCrumbs";

const DefectList = () => {
  const [defects, setDefects] = useState([]);
  const [loading, setLoading] = useState(true); // Estado para manejar la carga
  const [error, setError] = useState(null); // Estado para manejar errores

  useEffect(() => {
    const fetchDefects = async () => {
      try {
        const response = await getDefects();
        setDefects(response);
      } catch (error) {
        setError("Error al obtener los defetos del caso de prueba");
        console.error("Error al obtener los defectos", error);
      } finally {
        setLoading(false); // Se ejecuta independientemente de si hubo éxito o error
      }
    };

    fetchDefects();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDefect(id);
      setDefects(defects.filter((defect) => defect.id !== id));
    } catch (error) {
      console.error("Error al eliminar el defecto", error);
    }
  };

  if (loading) {
    return <p>Cargando...</p>; // Muestra un mensaje de carga mientras se espera la respuesta
  }

  if (error) {
    return <p>{error}</p>; // Muestra el mensaje de error si ocurrió algún problema
  }

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects/1/tests" },
    {
      name: "Defect",
      url: "/dashboard/projects/1/tests/defect",
    },
  ];

  return (
    <>
      <h2>Lista de Defectos</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <Link to="create" className="btn btn-primary mb-3">
        Crear Defecto
      </Link>

      {defects && defects.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Título</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {defects.map((defect) => (
              <tr key={defect.defectos_id}>
                <td>{defect.defectos_id}</td>
                <td>{defect.nombre}</td>
                <td>{defect.descripcion}</td>
                <td>{defect.estado}</td>
                <td>
                  <Link
                    to={`update/${defect.defectos_id}`}
                    className="btn btn-warning"
                  >
                    Editar
                  </Link>
                  <button
                    onClick={() => handleDelete(defect.defectos_id)}
                    className="btn btn-danger ms-2"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay defectos disponibles.</p>
      )}
    </>
  );
};

export default DefectList;
